import { render, staticRenderFns } from "./RecordsFromCSV.vue?vue&type=template&id=a808767e"
import script from "./RecordsFromCSV.vue?vue&type=script&lang=js"
export * from "./RecordsFromCSV.vue?vue&type=script&lang=js"
import style0 from "./RecordsFromCSV.vue?vue&type=style&index=0&id=a808767e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports